
import { Observable, of } from 'rxjs'
import { UserProfile } from 'se-resource-types/dist/lib/CentralService/Households'
import { RemovePersonaModalSubmitter } from '../../lib/remove-persona-modal/remove-persona-modal-submit.service'

export class DocsRemovePersonaModalSubmitter implements RemovePersonaModalSubmitter {
  public error: string

  public submit(profile: UserProfile): Observable<any> {
    console.log('submit', profile)
    return of(profile)
  }
}
